export const BACKUP_ENDPOINT = "/api/Backup";
